import React, {useMemo} from 'react';
import {Link} from 'react-router-dom';

import Group from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';
import {Message} from '@pb/kit-component-message';
import Typography from '@pb/kit-component-typography';

import {useUserPrimaryAccountName} from '../../hooks/use-user-primary-account-name';
import {SUPPORT_EMAIL, buildSupportMailto} from '../../utils/build-support-mailto';

import {draftLockedContainer} from './draft-locked-by-other-user.module.styl';

export const DraftLockedByOtherUser: React.FC = () => {
    const {accountName, accountId} = useUserPrimaryAccountName();
    const supportMailto = useMemo(
        () => buildSupportMailto({accountName, accountId}),
        [accountName, accountId],
    );

    return (
        <Group direction="v" gap="l" className={draftLockedContainer}>
            <Typography variant="heading-level-1">
                SSO Setup In Progress
            </Typography>

            <Message color="warning">
                Another administrator is currently setting up SSO for your organization.
            </Message>

            <Typography variant="body-level-1">
                Please contact <a href={supportMailto}>{SUPPORT_EMAIL}</a> for assistance.
            </Typography>

            <Group gap="xxs" alignItems="center">
                <Icon type={Icons.ENVELOPE} size="Size_12"/>
                Need help?&nbsp; Contact us at
                <Link to={supportMailto}>
                    {SUPPORT_EMAIL}
                </Link>
            </Group>
        </Group>
    );
};
